//包含了多个直接修改状态数据的方法和对象
export default {}